function Footer() {
  return (
    <div className='fixed bottom-0 mt-auto w-full overflow-hidden bg-black py-12 '>
      <div className='mx-auto flex max-w-2xl items-center justify-center'>
        <h2 className='text-4xl font-bold text-white sm:text-3xl'>
          By. pre-onboarding-11th-1-1
        </h2>
      </div>
    </div>
  );
}

export default Footer;
